import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { styled, Typography } from '@mui/material';
const Heading = styled(Typography)(({ theme }) => ({
    marginBottom: '0 !important',
    [theme.breakpoints.up('sm')]: {
        flexBasis: '33.33%',
        flexShrink: 0,
    },
}));
const SubHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    [theme.breakpoints.only('xs')]: {
        display: 'none',
    },
}));
export const AccordionHeader = memo(function AccordionHeader(props) {
    const { icon, heading, subheading } = props;
    return (_jsxs(_Fragment, { children: [icon, _jsx(Heading, { children: heading }), _jsx(SubHeading, { children: subheading })] }));
});
